<template>
  <div class="help">
    <div class="banner" ref="banner">
      <img src="../assets/banner6@2x.png" width="100%" alt />
      <el-row class="content">
        <el-col :span="24">
          <p>帮助文档</p>
          <p>HELP DOCUMENT</p>
        </el-col>
      </el-row>
    </div>

    <vue-drawer-layout>
      <div class="drawer" slot="drawer">
        <div class="text">
          <el-col :span="6">
            <div class="main_left1">
              <el-collapse v-model="activeNames" @change="handleChange">
                <el-collapse-item title="收银机软件问题" name="1">
                  <p>
                    <a href="#r1" @focus="one=1">激活店铺</a>
                  </p>
                  <p>
                    <a href="#r2" @focus="one=2">添加员工</a>
                  </p>
                  <p>
                    <a href="#r3" @focus="one=3">添加店家小票品牌名称</a>
                  </p>
                  <p>
                    <a href="#r4" @focus="one=4">前台收银交接班数据与后台查询销售数据不符</a>
                  </p>
                  <p>
                    <a href="#r5" @focus="one=5">软件升级</a>
                  </p>
                  <p>
                    <a href="#r6" @focus="one=6">还没有扫描枪和小票打印机可以安装收银系统吗？</a>
                  </p>
                  <p>
                    <a href="#r7" @focus="one=7">退款</a>
                  </p>
                  <p>
                    <a href="#r8" @focus="one=8">维修</a>
                  </p>
                  <p>
                    <a href="#r9" @focus="one=9">盘点单生成</a>
                  </p>
                </el-collapse-item>
                <el-collapse-item title="优惠方式" name="2">
                  <p>
                    <a href="#r10" @focus="one=10">店铺打折设置</a>
                  </p>
                </el-collapse-item>
                <el-collapse-item title="商品设置" name="3">
                  <p>
                    <a href="#r11" @focus="one=11">添加商品</a>
                  </p>
                  <p>
                    <a href="#r12" @focus="one=12">商品修改价格</a>
                  </p>
                </el-collapse-item>
              </el-collapse>
            </div>
          </el-col>
        </div>
      </div>
      <div class="content" slot="content">
        <div class="text"></div>
      </div>
    </vue-drawer-layout>

    <main>
      <el-row>
        <el-col :lg="{span:16,offset:4}" :md="{span:24,offset:0}">
          <el-row>
            <el-col :span="6" id="showDays" :class="headerf? 'isfixed': '' ">
              <div class="main_left">
                <el-collapse v-model="activeNames" @change="handleChange">
                  <el-collapse-item title="收银机软件问题" name="1">
                    <p>
                      <a href="#r1" @focus="one=1">激活店铺</a>
                    </p>
                    <p>
                      <a href="#r2" @focus="one=2">添加员工</a>
                    </p>
                    <p>
                      <a href="#r3" @focus="one=3">添加店家小票品牌名称</a>
                    </p>
                    <p>
                      <a href="#r4" @focus="one=4">前台收银交接班数据与后台查询销售数据不符</a>
                    </p>
                    <p>
                      <a href="#r5" @focus="one=5">软件升级</a>
                    </p>
                    <p>
                      <a href="#r6" @focus="one=6">还没有扫描枪和小票打印机可以安装收银系统吗？</a>
                    </p>
                    <p>
                      <a href="#r7" @focus="one=7">退款</a>
                    </p>
                    <p>
                      <a href="#r8" @focus="one=8">维修</a>
                    </p>
                    <p>
                      <a href="#r9" @focus="one=9">盘点单生成</a>
                    </p>
                  </el-collapse-item>
                  <el-collapse-item title="优惠方式" name="2">
                    <p>
                      <a href="#r10" @focus="one=10">店铺打折设置</a>
                    </p>
                  </el-collapse-item>
                  <el-collapse-item title="商品设置" name="3">
                    <p>
                      <a href="#r11" @focus="one=11">添加商品</a>
                    </p>
                    <p>
                      <a href="#r12" @focus="one=12">商品修改价格</a>
                    </p>
                  </el-collapse-item>
                </el-collapse>
              </div>
            </el-col>
            <el-col :span="17" :xs="{span:24}" class="mains">
              <div class="main_right">
                <div class="item" id="r1">
                  <span :style="one ==1 ? 'background-color: #258ffc; color: #fff;' :'' " >如何激活店铺</span>
                  <br />
                  <p>打开经理云的官网，注册老板账号，获得权限。在门店收银机用老板账号激活收银机。</p>
                </div>
                <div class="item" id="r2">
                  <span :style="one ==2 ? 'background-color: #258ffc; color: #fff;' :'' ">添加员工</span>
                  <br />
                  <p>老板激活经理云收银机后，员工输入用户名，密码，身份证号等一些相关信息注册员工账号。老板会根据相应的职位给相应的权限。</p>
                </div>
                <div class="item" id="r3">
                  <span
                    :style="one ==3 ? 'background-color: #258ffc;color: #fff;' :'' "
                  >店家小票品牌名称如何添加？</span>
                  <br />
                  <p>激活经理云收银机--填写老板信息--填写店铺名称，地址等相关资料后，会按照格式把店铺名称，地址，电话，销售件数，价格，等打印在小票上。</p>
                </div>
                <div class="item" id="r4">
                  <span
                    :style="one ==4 ? 'background-color: #258ffc; color: #fff;' :'' "
                  >前台收银交班数据和后台查询销售数据为何不一致？</span>
                  <br />
                  <p>首先请确认查询的时间范围是否一致，查询报表对象是否正确！然后检查前台数据是否正常上传(网络版断网或者数据库损坏情况下，有可能导致前台数据无法上传)，再者有可能是电脑日期被随意篡改之后，导致前台营业数据和后台不一致。因为电脑是按时间统计数据.如果之前有篡改过日期，导致日期错误，有可能会导致之前的日期和现在的日期数据合并在一起，从而导致数据查询不准确。</p>
                </div>
                <div class="item" id="r5">
                  <span :style="one ==5 ? 'background-color: #258ffc; color: #fff;' :'' ">软件怎么升级？</span>
                  <br />
                  <p>软件升级会自动在后台下载升级版本，下载完成后会自动弹出安装页面，点击安装即可。</p>
                </div>
                <div class="item" id="r6">
                  <span
                    :style="one ==6? 'background-color: #258ffc; color: #fff;' :'' "
                  >还没有扫描枪和小票打印机可以安装收银系统吗？</span>
                  <br />
                  <p>没有扫描枪的情况下，可以输入商品编码，跟扫描枪没有区别，当然采用扫描枪会更方便快速。小票打印机，我们收银机自带小票打印机，不需要购买其他的打印机。</p>
                </div>
                <div class="item" id="r7">
                  <span :style="one ==7? 'background-color: #258ffc; color: #fff;' :'' ">退款</span>
                  <br />
                  <p>在营业的模块选择销售单查找商品单号点击详情，点击右上角退款输入退货数量即价格即可退货。</p>
                </div>
                <div class="item" id="r8">
                  <span :style="one ==8? 'background-color: #258ffc; color: #fff;' :'' ">维修</span>
                  <br />
                  <p>在营业的模块选择销售单查找商品单号点击详情，点击右上角维修输入维修数量即可。</p>
                </div>
                <div class="item" id="r9">
                  <span :style="one ==9? 'background-color: #258ffc; color: #fff;' :'' ">盘点单生成</span>
                  <br />
                  <p>选择盘点在有问题的商品列表后面选择，“-”代表商品少一件“+”代表商品多一件，选择完成后页面下有备注说明该商品因什么少一件或因什么多一件；点击盘点单生成即可。</p>
                </div>
                <div class="item" id="r10">
                  <span :style="one ==10? 'background-color: #258ffc; color: #fff;' :'' ">店铺打折设置</span>
                  <br />
                  <p>顾客选好商品后，如折扣商品，收银员在收银机上按照相应折扣设置打折度（比如5折选择折扣那栏把折扣改成5，代表5折之类的就可以操作的）。</p>
                </div>
                <div class="item" id="r11">
                  <span :style="one ==11? 'background-color: #258ffc; color: #fff;' :'' ">添加商品</span>
                  <br />
                  <p>登入后台下载入库模板填入商品信息点击商品管理商品入库选择门店，导入商品选择导入的文件夹点击上传即可。</p>
                </div>
                <div class="item" id="r12">
                  <span :style="one ==12? 'background-color: #258ffc; color: #fff;' :'' ">商品修改价格</span>
                  <br />
                  <p>在入库模板中填入要改价格的商品信息只把金额改变，点击商品管理商品入库选择门店，导入商品选择导入的文件夹点击上传即可。</p>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </main>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeNames: "1",
      one: 1,
      headerf: 0
    };
  },
  mounted() {
    // 监听dom渲染完成
    this.$nextTick(function() {
      // 这里fixedHeaderRoot是吸顶元素的ID
      let header = document.getElementById("showDays");

      // 这里要得到top的距离和元素自身的高度
      this.offsetTop = header.offsetTop;
      this.offsetHeight = header.offsetHeight;

      console.log("offsetTop:" + this.offsetTop + "," + this.offsetHeight);
    });
    // handleScroll为页面滚动的监听回调
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      let header = document.getElementById("showDays");
      // 头部banner的高度
      let bannerheight = this.$refs.banner.clientHeight;
      // 得到页面滚动的距离
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // 判断页面滚动的距离是否大于吸顶元素的位置
      this.headerFixed = scrollTop > this.offsetTop - this.offsetHeight * 2;
      if (scrollTop - bannerheight > 0) {
        this.headerf = 1;
      } else {
        this.headerf = 0;
      }
    },
    handleChange(val) {}
  }
};
</script>

<style lang="less" scoped>
.help {
  header {
    position: relative;
  }
  .banner {
    // height: 319px;
    // background: url("../assets/banner6@2x.png") no-repeat top center;
    // background-size: 100%;
    // padding: 130px 0;
    // min-width: 1200px;
    position: relative;
    .content {
      p {
        &:nth-of-type(1) {
          font-size: 28px;
          font-weight: 800;
        }
        &:nth-of-type(2) {
          font-size: 12px;
        }
        @media screen and (max-width: 850px) {
          &:nth-of-type(1) {
            font-size: 14px;
            font-weight: 800;
          }
          &:nth-of-type(2) {
            font-size: 10px;
          }
        }
      }
      position: absolute;
      width: 100%;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      text-align: center;
      color: #fff;
    }
  }
  main {
    height: 2500px;
    background-color: #f0efef;
    @media screen and (max-width: 850px) {
      height: 1800px;
      .main_left {
        display: none;
      }
      .mains {
        margin-left: 0 !important;
        .main_right {
          width: 100%;
          // min-width: 375px;
          padding: 10px 40px 10px 20px;
          .item {
            span {
              padding: 5px 7px;
              font-size: 14px;
            }
            p {
              font-size: 12px;
              line-height: 15px;
            }
          }
        }
      }
    }
    .isfixed {
      position: fixed;
      top: 70px;
      left: 0;
      // transform: translateX(-200%);
      // width: 255px;
    }
    .main_left {
      position: relative;
      /deep/.el-collapse-item__header {
        color: #258ffc;
        font-size: 20px;
        font-weight: 800;
        font-family: MicrosoftYaHei;
      }
      min-width: 215px;
      background-color: #fff;
      padding: 20px;
      p {
        line-height: 16px;
        margin-top: 20px;
        font-family: MicrosoftYaHei;
        a {
          font-size: 16px;
          color: #323232;
          &:hover,
          &:active {
            color: #258ffc;
            font-weight: 800;
          }
        }
      }
      @media screen and (max-width: 850px) {
        /deep/.el-collapse-item__header {
          color: #258ffc;
          font-size: 16px;
          font-weight: 400;
          font-family: MicrosoftYaHei;
        }
        width: 187px;
        padding: 10px;
        p {
          margin-top: 10px;
          a {
            font-size: 12px;
          }
        }
      }
    }
    .mains {
      margin-left: 35px;
      position: absolute;
      top: 0;
      right: 0;
      @media screen and (max-width: 850px) {
        position: unset;
      }
    }
    .main_right {
      background-color: #fff;
      padding: 20px 80px 20px 40px;
      // min-width: 530px;
      .item {
        margin: 50px 0;
        &:target{
          padding-top: 80px;
        }
        span {
          padding: 10px 15px;
          font-weight: 400;
          font-size: 22px;
          // background-color: #f0efef;
          border-top: 100px;
          color: #323232;
          white-space: nowrap;
          
        }
        p {
          margin-top: 30px;
          font-size: 18px;
          color: #666;
          line-height: 30px;
          // text-indent: 2em;
        }
      }
    }
  }
  @media screen and (min-width: 850px) {
    .drawer-layout{
      display: none;
    }
  }
  .drawer-layout {
    position: fixed;
    height: 100%;
    z-index: 70;
    .main_left1 {
      position: relative;
      top: 80px;
      /deep/.el-collapse-item__header {
        color: #258ffc;
        font-size: 16px;
        font-weight: 400;
        font-family: MicrosoftYaHei;
      }
      min-width: 187px;
      background-color: #fff;
      padding: 10px;
      p {
        line-height: 16px;
        margin-top: 10px;
        font-family: MicrosoftYaHei;
        a {
          font-size: 12px;
          color: #323232;
          &:hover,
          &:active {
            color: #258ffc;
            font-weight: 800;
          }
        }
      }
    }
  }
}
</style>